import { HOUR } from "./time.ts";

// Today's brief: the arithmetic over one's own recent posts (services/today.ts reads them).

/** Today's brief (docs/product-decisions.md 2026-11-03). X's views keep growing for about a day, so a younger post cannot be the worst. */
export const TODAY_RULES = { posts_hours: 48, worst_after_hours: 24 } as const;

export type TodayPostKind = "post" | "reply" | "quote";
interface TodayPostInput { id: string; kind: string; views: number | null; posted_at: number }

/** One's own recent posts by kind, with the best and worst of those X gave a number for. Unknown views stay out of every sum. */
export function todayPosts(posts: TodayPostInput[], now: number) {
  const known = (rows: TodayPostInput[]) => rows.filter((post): post is TodayPostInput & { views: number } => post.views !== null);
  const total = (rows: TodayPostInput[]) => (known(rows).length ? known(rows).reduce((sum, post) => sum + post.views, 0) : null);
  const kinds = (["post", "reply", "quote"] as const).flatMap((kind) => {
    const rows = posts.filter((post) => post.kind === kind);
    if (!rows.length) return [];
    const views = total(rows);
    return [{ kind, count: rows.length, views, average: views === null ? null : Math.round(views / known(rows).length) }];
  });
  const ranked = [...known(posts)].sort((a, b) => b.views - a.views);
  const settled = ranked.filter((post) => now - post.posted_at >= TODAY_RULES.worst_after_hours * HOUR);
  const best = ranked[0] ?? null;
  const worst = settled.at(-1) ?? null;
  return { views: total(posts), kinds, best, worst: worst && worst.id !== best?.id ? worst : null };
}
